module.exports = __webpack_public_path__ + "media/assets/avia/search/babis-b12fca0184137ee9995bb4a16f24b3f5.png";